import React from 'react';

import {
  Redirect,
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';

import { Home } from './home';
import { AmContainer } from '../../controls';
import { Http404, PrivacyPolicy, Tos } from '../../shared';

const Authorized = () => {
  return (
    <div className="App">
      <header className="App-header">
        <AmContainer>
          <Router>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/tos" component={Tos} />
              <Route exact path="/privacy-policy" component={PrivacyPolicy} />
              <Redirect from="/signin" to="/" />
              <Route exact path="*" component={Http404} />
            </Switch>
          </Router>
        </AmContainer>
      </header>
    </div>
  );
};

export { Authorized };
